var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",class:{ 'gx-canvas': true, 'gx-canvas--fixed': _vm.fixed },style:({ opacity: _vm.opacity })})
}
var staticRenderFns = []

export { render, staticRenderFns }